/**
 * Subscription Type Codes
 * These match the backend subscription types
 */
export const SUBSCRIPTION_TYPES = {
  ALL: 'ALL',
  TD: 'TD', // Teladoc
  COURSES: 'COURSES', // Category: includes BETF, BGT, RH and SZKTTF
  NAME_FINDER: 'NAME_FINDER', // Category: includes UK1 and UK8
  BETF: 'BETF', // Babaelsősegély tanfolyam (Baby First Aid Course)
  BGT: 'BGT', // Babagondozási tanfolyam (Baby Care Course)
  RH: 'RH', // Relaxációs hanganyagok (Relaxation Audio)
  SZKTTF: 'SZKTTF', // Szülésre készítő torna (Prenatal Exercises)
  UK1: 'UK1', // Utónévkereső 1 hónap (Name Finder 1 month)
  UK8: 'UK8', // Utónévkereső 8 hónap (Name Finder 8 months)
  PREMIUM_V1: 'PREMIUM_V1', // Prémium V1 előfizetések (old bundle subscriptions)
};

/**
 * Get dropdown options for type selector
 * @returns {Array} Array of {value, label} objects
 */
export const getTypeOptions = () => {
  return [
    { value: 'ALL', label: 'Összes (All)' },
    { value: 'TD', label: 'Teladoc' },
    { value: 'COURSES', label: 'Tanfolyamok (Courses)' },
    { value: 'NAME_FINDER', label: 'Utónévkereső (Name Finder)' },
  ];
};

/**
 * Get dropdown options for type selector including Premium V1
 * @returns {Array} Array of {value, label} objects
 */
export const getTypeOptionsWithPremiumV1 = () => {
  return [
    { value: 'ALL', label: 'Összes (All)' },
    { value: 'TD', label: 'Teladoc' },
    { value: 'COURSES', label: 'Tanfolyamok (Courses)' },
    { value: 'NAME_FINDER', label: 'Utónévkereső (Name Finder)' },
    { value: 'PREMIUM_V1', label: 'Premium V1' },
  ];
};
